import { AGE_ALLOWED } from "./types";

export const ageAllowedAction = (val) => {
  return {
      type: AGE_ALLOWED,
      payload: val
  }
}
